export class DocsPath {
  name: string = "";
  fullPath: string = "";
}
